import React from "react";
import { Button, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonWithEndIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding button with end icon"}
        value={
          '<Button variant={"noPadding"} endIcon={<ArrowRightIcon />} color={"success"}>Next</Button>'
        }
      >
        <Button
          variant={"noPadding"}
          endIcon={<ArrowRightIcon />}
          color={"success"}
        >
          Next
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonWithEndIcon;
